import { AxiosResponse } from 'axios';

import { isMobileApp } from '../util/isMobileApp';

export const sendSessionToMobile = (data: AxiosResponse) => {
  if (isMobileApp) {
    const token = data?.data?.refresh_token;
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        refreshToken: token,
      })
    );
  }
};
